<template>
    <!-- 练习统计 -->
    <el-card class="user-traincount">
        <div slot="header">
            <el-radio-group size="small" v-model="practice">
                <el-radio-button :label="1">按人员统计</el-radio-button>
                <!-- <el-radio-button :label="2">按数据库统计</el-radio-button> -->
            </el-radio-group>
        </div>
        <div>
            <template v-if="practice === 1">
                <el-row>
                    <el-col :span="20">
                        <el-alert
                            title="注：web端练习统计数据每天24点后进行更新"
                            type="warning"
                            :closable="false"
                            style="padding:6px 16px;"
                        ></el-alert>
                    </el-col>
                    <el-col class="text-r" :span="4">
                        <el-button size="small" type="primary">Excel导出</el-button>
                    </el-col>
                    <el-col :span="24">
                        <el-form
                            class="screen-form-inline"
                            size="small"
                            :inline="true"
                            :model="formInline"
                        >
                            <el-form-item label="年份">
                                <el-select
                                    clearable
                                    v-model="formInline.year"
                                    placeholder="请选择年份"
                                    style="width:136px"
                                >
                                    <el-option label="2019" :value="2019"></el-option>
                                    <el-option label="2018" :value="2018"></el-option>
                                    <el-option label="2017" :value="2017"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="月份">
                                <el-select
                                    clearable
                                    v-model="formInline.mouth"
                                    placeholder="请选择月份"
                                    style="width:136px"
                                >
                                    <el-option label="1月" :value="1"></el-option>
                                    <el-option label="2月" :value="2"></el-option>
                                    <el-option label="3月" :value="3"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="周期">
                                <el-select
                                    clearable
                                    v-model="formInline.week"
                                    placeholder="请选择周期"
                                    style="width:200px"
                                >
                                    <el-option label="8/04 ~ 8/10" value="08040810"></el-option>
                                    <el-option label="8/11 ~ 8/17" value="08110817"></el-option>
                                    <el-option label="8/18 ~ 8/24" value="08180824"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item>
                                <el-input
                                    clearable
                                    placeholder="请输入姓名"
                                    v-model="formInline.user"
                                    style="width:250px"
                                >
                                    <el-button slot="append" icon="el-icon-search"></el-button>
                                </el-input>
                            </el-form-item>
                        </el-form>
                    </el-col>
                    <el-table stripe style="width: 100%" :data="tableData">
                        <el-table-column prop="username" label="姓名"></el-table-column>
                        <el-table-column prop="rightNum" label="答对量"></el-table-column>
                        <el-table-column prop="totalNum" label="作答量（已去重）"></el-table-column>
                        <el-table-column label="正确率">
                            <template
                                slot-scope="scope"
                            >{{Number((scope.row.rightNum / scope.row.totalNum * 100).toFixed(0))}}%</template>
                        </el-table-column>
                        <!-- <el-table-column label="操作">
                            <template slot-scope="scope">
                                <el-button
                                    @click="handleClick(scope.row.userId)"
                                    type="text"
                                    size="small"
                                >查看详情</el-button>
                            </template>
                        </el-table-column> -->
                    </el-table>
                </el-row>
            </template>
            <template v-else>
                <el-form class="screen-form-inline" size="small" :inline="true" :model="formInline">
                    <el-form-item>
                        <el-input clearable placeholder="请输入数据库名" v-model="formInline.dbName">
                            <el-button slot="append" icon="el-icon-search"></el-button>
                        </el-input>
                    </el-form-item>
                </el-form>
                <el-table stripe style="width: 100%" :data="tableData">
                    <el-table-column prop="name" label="企业题库名称"></el-table-column>
                    <el-table-column prop="num" label="练习员工"></el-table-column>
                    <el-table-column label="操作">
                        <template>
                            <el-button type="text" size="small">查看详情</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </template>
            <!-- <el-pagination prev-text="上一页" next-text="下一页"
                        layout="total, prev, pager, next, jumper"
                        :total="page.total"
                        :current-page="page.page"
                        :page-size="page.limit"
                        :pager-count="page.pagerCount"
                        @size-change="handleLimitChange"
                        @current-change="handlePageChange">
            </el-pagination>-->
        </div>
    </el-card>
</template>

<script>
import { selectUserTotal } from "@/api/exam/etuserquestionhistory";
export default {
    data() {
        return {
            practice: 1, // 统计方式
            page: {
                page: 1, // 当前页
                limit: 10, // 每页条目数
                total: 0,
                pagerCount: 7 // 页码按钮的数量，当总页数超过该值时会折叠(大于等于 5 且小于等于 21 的奇数)
            },
            formInline: {},
            tableData: []
        };
    },
    methods: {
        init() {
            this.getPracticeTotal();
        },
        getPracticeTotal() {
            selectUserTotal().then(res => {
                this.tableData = res;
            });
        },
        // 分页查询用户错题本
        getWQs() {
            // let { limit, page } = this.page;
            // this.wrongQuestionList = [];
            // getWrongQuestions(page, limit, params).then(res => {
            //     let { list, totalCount } = res;
            //     let questions = formatQuestions(list)
            //     this.wrongQuestionList = list;
            //     this.$set(this.page, 'total', totalCount);
            // })
        },
        // limit 改变时会触发
        handleLimitChange(limit) {
            this.$set(this.page, "limit", limit);
            // this.getWQs();
        },
        // page 改变时会触发
        handlePageChange(page) {
            this.$set(this.page, "page", page);
            // this.getWQs();
        },
        // 点击“查看详情”按钮
        handleClick(id) {
            this.$router.push({
                name: "examPracticeStatisticsUser",
                params: { id }
            });
        }
    },
    created() {
        this.init();
    }
};
</script>

<style lang="scss" scoped>
.user-traincount {
    .screen-form-inline {
        margin-top: 12px;
    }
}
</style>